import type { InviteUsersFailedRowDto } from '@/types/generated/schemas';
import type { TParsedRosterList } from '@/store/useOrganizationOnboardingStore';
import { getInviteFailureReason } from '@/utils/inviteFailures';
import RosterErrorSummary from './RosterErrorSummary';

const InviteFailures = ({ failed, roster }: { failed: InviteUsersFailedRowDto[]; roster?: TParsedRosterList }) => {
  return (
    <RosterErrorSummary
      issues={failed.map((row) => {
        const member = roster?.[row.rowIndex];
        const name = [member?.['First Name'], member?.['Last Name']].filter(Boolean).join(' ');
        return {
          label: name || row.email || 'Member',
          reason: getInviteFailureReason(row),
          rowIndex: row.rowIndex,
        };
      })}
      afterInvite
    />
  );
};

export default InviteFailures;
